import { connect } from 'react-redux'
import AmazonS3Inputs from './AmazonS3Inputs.component'
import * as Actions from 'state/actions'

const mapStateToProps = state => {
  return {
    accessKey: state.analyticsExport.exportApiConfig.amazonS3.accessKey,
    secretAccessKey: state.analyticsExport.exportApiConfig.amazonS3.secretAccessKey,
    region: state.analyticsExport.exportApiConfig.amazonS3.region,
    endpoint: state.analyticsExport.exportApiConfig.amazonS3.endpoint,
    bucketName: state.analyticsExport.exportApiConfig.amazonS3.bucketName,
    isFetching: state.analyticsExport.exportApiConfig.isFetchingExportApiConfig,
    isSaving: state.analyticsExport.exportApiConfig.isFetchingExportApiConfig
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateExportApiConfig: key => e => dispatch(Actions.updateExportApiAmazonS3Config(key, e.target.value))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AmazonS3Inputs)
